import * as Cesium from "cesium";
import React from "react";

import useViewerStore from "../stores/useViewerStore";
import c4SiteGeojson from "./c4SiteGeojson";

export default function useC4Boundary({ show }: { show: boolean }) {
  const { viewer } = useViewerStore();

  React.useEffect(() => {
    console.log("show", show);

    if (!viewer || !show) return;
    console.log("viewer", viewer);

    const geoJsonDataSource = new Cesium.GeoJsonDataSource();
    geoJsonDataSource
      .load(c4SiteGeojson, {
        stroke: Cesium.Color.RED,
        fill: Cesium.Color.RED.withAlpha(0.2),
        strokeWidth: 3,
      })
      .then((dataSource) => {
        dataSource.entities.values.forEach((entity) => {
          if (entity.polygon) {
            // 폴리곤의 각 위치에 대해 높이 오프셋 적용
            // eslint-disable-next-line no-param-reassign
            entity.polygon.height = new Cesium.ConstantProperty(1); // 1m 높이 설정
          }
        });
        viewer.dataSources.add(dataSource);
      })
      .catch((error) => {
        console.error("Error adding GeoJSON data:", error);
      });

    // eslint-disable-next-line consistent-return
    return () => {
      viewer.dataSources.remove(geoJsonDataSource);
    };
  }, [viewer, show]);
}
